import React, { useState } from 'react';
import styles from './cover.module.less';
import { getFileTypeFromUrl } from './utils';

export default ({ url, itemWidth }) => {
  const [activeUrl, setActiveUrl] = useState(null);

  const handleMediaClick = (url) => {
    setActiveUrl(url);
  };

  const handleClosePreview = () => {
    setActiveUrl(null);
  };

  return (
    <div className={styles.gallery}>
      <div
        className={styles.galleryItem}
        style={{ width: itemWidth }}
      >
        {getFileTypeFromUrl(url) === 'image' && (
          <img src={url} onClick={() => handleMediaClick(url)} />
        )}
        {getFileTypeFromUrl(url) === 'video' && (
          <video src={url}></video>
        )}
      </div>

      {activeUrl !== null && (
        <div className={styles.previewOverlay} onClick={handleClosePreview}>
          <div className={styles.previewContent}>
            <img src={activeUrl} width="80%" />
          </div>
        </div>
      )}
    </div>
  );
};
